import React from 'react';
import Icon from '../../../components/AppIcon';

const ProblemSection = () => {
  const problems = [
    {
      id: 1,
      icon: 'AlertCircle',
      title: 'Scattered Planning Tools',
      description: 'SMEs struggle with multiple disconnected tools for business planning, financial forecasting, and goal tracking, leading to inefficiency and data silos.'
    },
    {
      id: 2,
      icon: 'TrendingDown',
      title: 'Lack of Predictive Insights',
      description: 'Traditional planning methods rely on historical data without AI-powered predictions, making it difficult to anticipate market changes and growth opportunities.'
    },
    {
      id: 3,
      icon: 'Target',
      title: 'Unclear Goal Alignment',
      description: 'Business owners often set ambitious goals without understanding feasibility, resource requirements, or realistic timelines for achievement.'
    },
    {
      id: 4,
      icon: 'DollarSign',
      title: 'Financial Uncertainty',
      description: 'Without proper financial modeling and scenario analysis, businesses face unexpected cash flow issues and struggle with investment decisions.'
    }
  ];

  return (
    <section className="py-12 md:py-16 lg:py-20 px-4 md:px-6 lg:px-8 bg-muted/30">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-8 md:mb-12 lg:mb-16">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-destructive/10 border border-destructive/20 rounded-full mb-4">
            <Icon name="AlertTriangle" size={16} color="var(--color-destructive)" />
            <span className="text-xs md:text-sm font-medium text-destructive font-caption">
              Common Challenges
            </span>
          </div>
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-foreground mb-4">
            The Problems SMEs Face
          </h2>
          <p className="text-base md:text-lg text-muted-foreground font-body max-w-3xl mx-auto">
            Small and medium enterprises struggle with fragmented tools and lack of actionable insights, making strategic planning complex and time-consuming.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8">
          {problems?.map((problem) => (
            <div
              key={problem?.id}
              className="bg-card border border-border rounded-lg p-6 md:p-8 transition-smooth hover:elevation-md group"
            >
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 md:w-14 md:h-14 rounded-lg bg-destructive/10 flex items-center justify-center flex-shrink-0 transition-smooth group-hover:bg-destructive/20">
                  <Icon
                    name={problem?.icon}
                    size={24}
                    color="var(--color-destructive)"
                  />
                </div>
                <div className="flex-1 min-w-0">
                  <h3 className="text-lg md:text-xl font-heading font-semibold text-foreground mb-2">
                    {problem?.title}
                  </h3>
                  <p className="text-sm md:text-base text-muted-foreground font-body leading-relaxed">
                    {problem?.description}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ProblemSection;